/**
 * Created by Mark on 04/05/2017.
 */



import React   from 'react';
import Layout  from '../../components/layouts/standard-page.js';
import {Button , OverlayTrigger , Tooltip} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Link , hashHistory} from 'react-router'
import Card from '../../components/card.js';
import CardHead from '../../components/card-header.js';
import CardBody   from '../../components/card-body.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import AssignmentServices from '../../services/assignment-services.js';
import AssignmentStore from '../../store/assignment-store.js';

class BSTable extends React.Component {
    render() {
        if (this.props.data) {
            return (
                <BootstrapTable data={ this.props.data }>
                    <TableHeaderColumn dataField='fieldA' isKey={ true }>Field A</TableHeaderColumn>
                    <TableHeaderColumn dataField='fieldB'>Field B</TableHeaderColumn>
                    <TableHeaderColumn dataField='fieldC'>Field C</TableHeaderColumn>
                    <TableHeaderColumn dataField='fieldD'>Field D</TableHeaderColumn>
                </BootstrapTable>);
        } else {
            return (<p>?</p>);
        }
    }
}

export default class HomeworkOverview extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {assignment:false , homework:[]}
    }


    componentWillMount(){
        AssignmentServices.getViewableHomework();
    }

    componentDidMount(){
        AssignmentStore.on("ON_GET_HOMEWORK_FEATURES" , () => {

            console.log(AssignmentStore.viewableHomework);
            this.setState({homework:AssignmentStore.viewableHomework});
        });
    }

    getTableData(){
        return this.state.homework
    }

    renderTasks(cell){

        var tasks = [];

        for(var idx = 0 ; idx < cell.length; idx++){
            tasks.push(
                <li>
                    <FormattedMessage id={ 'ui-000' } defaultMessage={ cell[idx].name }/>
                </li>
            );
        }

        return <div>{tasks}</div>
    }

    isExpandableRow(row) {
        if (row.id < 2) return true;
        else return false;
    }

    render(){

        const tableOptions = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
        };

        return (<Layout>
                    <Card>
                        <CardHead>
                            <h2 className="pull-left">
                                <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Homework' }/>
                            </h2>
                            <span className="pull-right"><a>Homework Archive</a>&nbsp;|&nbsp;<a>Pending Homework</a></span>
                        </CardHead>
                        <CardBody >
                            <br />
                            <BootstrapTable options={tableOptions} data={ this.getTableData() } keyField='id'  condensed pagination  bordered={ false }>
                                <TableHeaderColumn  col='0' colSpan='1' dataField='name'   dataSort={ false }>
                                    <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Name' }/>
                                </TableHeaderColumn>
                                <TableHeaderColumn   dataFormat={this.renderTasks} col='0' colSpan='1' dataField='tasks'   dataSort={ false }>
                                    <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Tasks' }/>
                                </TableHeaderColumn>
                                <TableHeaderColumn  col='0' colSpan='1' dataField='totalStudents'   dataSort={ false }>
                                    <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Total Students' }/>
                                </TableHeaderColumn>
                                <TableHeaderColumn  col='0' colSpan='1' dataField='set'   dataSort={ false }>
                                    <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Set' }/>
                                </TableHeaderColumn>
                                <TableHeaderColumn  col='0' colSpan='1' dataField='due'   dataSort={ false }>
                                    <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Due' }/>
                                </TableHeaderColumn>
                            </BootstrapTable>
                        </CardBody>
                    </Card>
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/new_screens/homework-overview.js